import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Scannable QR carrying a signed JWT check-in token for the given registration id.
 * Falls back to a plain rendering (id text inside the QR) if the backend hasn't issued a token yet.
 */
export function RealQR({ regId, size = 220, className = "" }) {
  const [token, setToken] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!regId) return;
    setErr(null);
    axios
      .get(`${API}/registrations/${regId}/checkin-token`)
      .then((r) => { if (!cancelled) setToken(r.data.token); })
      .catch((e) => { if (!cancelled) setErr(e?.response?.data?.detail || "Pass will be ready after payment"); });
    return () => { cancelled = true; };
  }, [regId]);

  // value we encode. When token isn't ready yet, encode the reg id so the QR is still scannable
  // for demonstration purposes — the scanner will just reject it as an "invalid pass".
  const value = token || regId || "BNI-DEMO";

  return (
    <div className={className} style={{ background: "#F7F4EE", padding: 12, display: "inline-block", lineHeight: 0 }}>
      <QRCodeSVG
        value={value}
        size={size}
        level="M"
        bgColor="#F7F4EE"
        fgColor="#0B0D10"
        imageSettings={{
          src: "/bni-logo-light.png",
          height: size * 0.18,
          width: size * 0.18,
          excavate: true,
        }}
      />
      {err && (
        <div className="mono-label mt-2 text-center" style={{ color: "#8a8a8a", fontSize: 10 }}>
          {err}
        </div>
      )}
    </div>
  );
}
